
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { FormCoreModule } from '../core/form-core.module';
import { FormBuildService } from '../core/service/form-build.service';

import { FormTemplateModule } from '../template/template.module';
import { RegisterFormComponent } from './register-form/register-form.component';
import { LoginFormComponent } from './login-form/login-form.component';
import { RegisterCommerceFormComponent } from './register-commerce-form/register-commerce-form.component';
import { OfferFormComponent } from './offer-form/offer-form.component';
import { CommerceGeneralFormComponent } from './commerce-general-form/commerce-general-form.component';
import { AddressFormComponent } from './address-form/address-form.component';
import { LessorFormComponent } from './lessor-form/lessor-form.component';
import { PersonMoralFormComponent } from './person-moral-form/person-moral-form.component';
import { ContactCommerceFormComponent } from './contact-commerce-form/contact-commerce-form.component';
import { ContactFormComponent } from './contact-form/contact-form.component';
import { PersonFisicFormComponent } from './person-fisic-form/person-fisic-form.component';
import { CommerceReferencesFormComponent } from './commerce-references-form/commerce-references-form.component';
import { ReferenceFormComponent } from './reference-form/reference-form.component';
import { CommerceFinanceFormComponent } from './commerce-finance-form/commerce-finance-form.component';
import { TpvFormComponent } from './tpv-form/tpv-form.component';
import { CommerceVerificationFormComponent } from './commerce-verification-form/commerce-verification-form.component';
import { CommerceSocialNetworksFormComponent } from './commerce-social-networks-form/commerce-social-networks-form.component';
import { CommerceCasefileFormComponent } from './commerce-casefile-form/commerce-casefile-form.component';
import { CommerceAppointmentFormComponent } from './commerce-appointment-form/commerce-appointment-form.component';
import { BuroFormComponent } from './buro-form/buro-form.component';
import { AppComponentPluginModule } from '../../core/component/plugin/app-component-plugin.module';
import { PaybookModule } from '../../paybook/paybook.module';
import { SocialModule } from '../../social/social.module';
import { BillingStatementComponent } from './billing-statement/billing-statement.component';
import { PersonBuroFormComponent } from './person-buro-form/person-buro-form.component';
import { TemporalFormComponent } from './temporal-form/temporal-form.component';
import { AddressCommerceFormComponent } from './address-commerce-form/address-commerce-form.component';
import { TabsModule } from 'ngx-bootstrap';
import { CommerceInfoFormComponent } from './commerce-info-form/commerce-info-form.component';
import { CommerceSatFormComponent } from './commerce-sat-form/commerce-sat-form.component';
import { ObligadoSolidarioComponent } from './obligado-solidario/obligado-solidario.component';
import { ObligadoSolidarioDireccionComponent } from './obligado-solidario-direccion/obligado-solidario-direccion.component';



@NgModule({
  imports: [
    CommonModule,
    FormCoreModule,
    FormTemplateModule,
    FormsModule,
    ReactiveFormsModule,
    SocialModule,
    PaybookModule,
    TabsModule.forRoot(),
  ],
  declarations: [
    RegisterFormComponent,
    LoginFormComponent,
    RegisterCommerceFormComponent,
    OfferFormComponent,
    CommerceGeneralFormComponent,
    AddressFormComponent,
    LessorFormComponent,
    PersonMoralFormComponent,
    CommerceInfoFormComponent,
    PersonFisicFormComponent,
    ContactCommerceFormComponent,
    ContactFormComponent,
    CommerceReferencesFormComponent,
    ReferenceFormComponent,
    CommerceFinanceFormComponent,
    TpvFormComponent,
    CommerceVerificationFormComponent,
    CommerceSocialNetworksFormComponent,
    CommerceCasefileFormComponent,
    CommerceAppointmentFormComponent,
    CommerceSatFormComponent,
    BuroFormComponent,
    BillingStatementComponent,
    PersonBuroFormComponent,
    TemporalFormComponent,
    AddressCommerceFormComponent,
    ObligadoSolidarioComponent,
    ObligadoSolidarioDireccionComponent,
  ],
  exports: [
    SocialModule,
    PaybookModule,
    RegisterFormComponent,
    LoginFormComponent,
    RegisterCommerceFormComponent,
    OfferFormComponent,
    CommerceGeneralFormComponent,
    AddressFormComponent,
    LessorFormComponent,
    PersonMoralFormComponent,
    CommerceInfoFormComponent,
    PersonFisicFormComponent,
    ContactCommerceFormComponent,
    ContactFormComponent,
    CommerceReferencesFormComponent,
    ReferenceFormComponent,
    CommerceFinanceFormComponent,
    TpvFormComponent,
    CommerceVerificationFormComponent,
    CommerceSocialNetworksFormComponent,
    CommerceCasefileFormComponent,
    CommerceAppointmentFormComponent,
    CommerceSatFormComponent,
    BuroFormComponent,
    BillingStatementComponent,
    PersonBuroFormComponent,
    TemporalFormComponent,
    AddressCommerceFormComponent,
  ]
})
export class FormModule {

  constructor(private formBuildService: FormBuildService) {
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/form.module.ts